import { MenuItem } from "@mui/material";
import { useState } from "react";
import { Controls } from "@/main/services/constants/constantsControl";
import { getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";
import { useThreeDotsQuoteContext } from "../contex";
import WrapperModalBuyerManualAnswer from "../../boxCart/components/modalBuyerManualAnswer/modalBuyerManualAnswer";

interface IThreeDotsQuoteDirectAssignProps {
	guidQuote: string;
	guidClaim?: string;
	isQuoteManual: boolean;
	guidCompanyBuyer: string;
	canDownloadImages: boolean;
	onSuccess: () => void;
}
function ThreeDotsQuoteDirectAssign({
	guidQuote,
	guidClaim,
	guidCompanyBuyer,
	isQuoteManual,
	canDownloadImages,
	onSuccess,
}: IThreeDotsQuoteDirectAssignProps) {
	const { closeThreeDotsQuote } = useThreeDotsQuoteContext();

	const showButtonBuyerManualAnswer = isShowControlByElementId(Controls.IdBuyerManualAnswer) && isQuoteManual;

	const [isOpenModalBuyerManualAnswer, setIsOpenModalBuyerManualAnswer] = useState<boolean>(false);

	function handleClickAddManualPartAnswers() {
		setIsOpenModalBuyerManualAnswer(true);
		closeThreeDotsQuote();
	}

	if (!showButtonBuyerManualAnswer) return null;
	return (
		<>
			<MenuItem id={`id-option-button-buyerManualAnswer`} onClick={handleClickAddManualPartAnswers}>
				{getTranslateByKey("information.buyerManualAnswer")}
			</MenuItem>

			<WrapperModalBuyerManualAnswer
				isOpenModal={isOpenModalBuyerManualAnswer}
				guidCompanyBuyer={guidCompanyBuyer}
				guidQuote={guidQuote}
				guidClaim={guidClaim}
				canDownloadImages={canDownloadImages}
				onSuccess={onSuccess}
				setIsOpenModal={setIsOpenModalBuyerManualAnswer}
				closeModal={() => setIsOpenModalBuyerManualAnswer(false)}
			/>
		</>
	);
}

export { ThreeDotsQuoteDirectAssign };
